<div [ngClass]="themeService.isDarkMode() ? 'dark' : ''" class="app-container">
	@if (controlVisibilities()?.showHeader !== false) {
		<vb-lxp-header
			[centerImageSrc]="
				themeService.isDarkMode()
					? headerConfig().centerImageSrcDark
					: headerConfig().centerImageSrcLight
			"
			[centerImageAlt]="headerConfig().centerImageAlt"
			[logoLink]="headerConfig().logoLink"
			[logoLinkTarget]="headerConfig().logoLinkTarget"
		>
			<!-- Left section: Event info -->
			@if (raceInfo()) {
				<div header-left class="header-left-content">
					<div class="header-title-row">
						<span class="header-title">{{ raceInfo()?.champName }}</span>
						<div class="header-title-row flex-nowrap!">
							@if (!isMobile()) {
								<span class="header-subtitle">| {{ raceInfo()?.eventShortName }}</span>
								<span class="header-subtitle">| {{ raceInfo()?.name }}</span>
							}
							<vb-lxp-race-flag-indicator [raceStatus]="raceStatus()"></vb-lxp-race-flag-indicator>
						</div>
					</div>
					@if (!isSessionArchived()) {
						<div class="header-timing-row">
							@if (isMobile()) {
								<span class="header-subtitle">| {{ raceInfo()?.eventShortName }}</span>
								<span class="header-subtitle">| {{ raceInfo()?.name }}</span>
							}
						</div>
					} @else {
						<span class="header-timing-row">No current track activity</span>
					}
				</div>
			}

			<!-- Right section -->
			<div header-right class="header-right-content">
				<!-- Layout buttons -->
				@if (raceInfo() && controlVisibilities().showLayoutControls && !isSessionArchived()) {
					<div class="main-stream-toggle" (click)="livestreamViewService.onMainStreamToggled(!livestreamViewService.isMainStreamSelected())">
						<span class="main-stream-toggle-title">Main Stream</span>
						<vb-lxp-switch
							[checked]="livestreamViewService.isMainStreamSelected()"
						></vb-lxp-switch>
					</div>
				}
				@if (
					raceInfo() &&
					controlVisibilities().showLayoutControls &&
					!isMobile() &&
					!isSessionArchived()
				) {
					<vb-lxp-layout-selector></vb-lxp-layout-selector>
				}

				<!-- Panel Toggle Buttons - Only show on desktop/tablet -->
				<div class="header-panel-toggles">
					@if (controlVisibilities().showTimingControl && !isSessionArchived()) {
						<button
							class="header-panel-toggle timing"
							[class.active]="isTimingActive()"
							title="Toggle Live Timing"
							(click)="toggleTiming()"
						>
							<i class="bi bi-stopwatch"></i>
							<span class="toggle-label">Timing</span>
						</button>
					}
					@if (controlVisibilities().showMapControl) {
						<app-race-class
							[classes]="raceClasses()"
							(selectionChange)="onClassSelectionChange($event)"
						></app-race-class>
						<button
							class="header-panel-toggle timing"
							[class.active]="isMapActive()"
							title="Toggle Live Timing"
							(click)="toggleMap()"
						>
							<i class="bi bi-map"></i>
							<span class="toggle-label">Map</span>
						</button>
					}
					@if (controlVisibilities().showChatControl) {
						<button
							class="header-panel-toggle chat"
							[class.active]="isChatActive()"
							title="Toggle Twitch Chat"
							(click)="toggleChat()"
						>
							<svg fill="currentColor" viewBox="0 0 24 24">
								<path
									d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"
								/>
							</svg>
							<span class="toggle-label">Chat</span>
						</button>
					}
				</div>

				<!-- Themes toggle -->
				<vb-lxp-theme-toggle></vb-lxp-theme-toggle>
			</div>
		</vb-lxp-header>
	}

	@if (!isAdminRoute()) {
		<vb-lxp-notification [notification]="currentNotification()"></vb-lxp-notification>
	}

	<main class="main-content">
		<router-outlet></router-outlet>
	</main>

	@if (controlVisibilities()?.showFooter !== false) {
		<vb-lxp-footer [imagePaths]="footerImages()">
			@if (isMobile()) {
				<div footer-tabs class="mobile-panel-toggles-fixed mobile-panel-footer">
					@if (controlVisibilities().showTimingControl) {
						<button
							class="mobile-panel-btn timing"
							[class.active]="isTimingActive()"
							(click)="toggleTiming()"
						>
							<i class="bi bi-stopwatch"></i>
							<span>Timing</span>
						</button>
					}
					@if (controlVisibilities().showChatControl) {
						<button
							class="mobile-panel-btn chat"
							[class.active]="isChatActive()"
							(click)="toggleChat()"
						>
							<svg fill="currentColor" viewBox="0 0 24 24">
								<path
									d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"
								/>
							</svg>
							<span>Chat</span>
						</button>
					}
				</div>
			}
		</vb-lxp-footer>
	}
</div>
